import { Component, OnInit } from '@angular/core';
import { EffectifsService } from '../../../../effectif/effectifs.service';

import { EffectifModel } from '../../../../models/effectif/effectif.model';
import { ModeEffectif, Option } from '../../../../models/effectif/option.model';
import { CoreService } from '../../../../services';
import { StageService } from '../services/stage-modal.service';



@Component({
  providers: [EffectifsService],
  selector: 'queoval-stage-effectif',
  templateUrl: './effectif.component.html',
  styleUrls: ['./effectif.component.css']
})

export class EffectifComponent implements OnInit {
  constructor(
    public service: StageService,
    public effectifService: EffectifsService,
    public indParam: CoreService,
  ) { }


  public OptionStagiaire: Option;
  public OptionFormateur: Option;
  public OptionClient: Option;
  public OptionPreinscrits: Option;
  public EffectifModel: EffectifModel = new EffectifModel();

  public clientService: EffectifsService;
  public stagiaireService: EffectifsService;

  public AdresseMap: string;
  public ngOnInit(): void {
    this.OptionStagiaire = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.STAGIAIRECLIENT);
    this.OptionFormateur = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.ALLFORMATEUR);
    this.OptionClient = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.ALLCLIENT);
    this.OptionPreinscrits = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.PREINSCRITS);
  }

  public getLieu(output: string) {
    this.AdresseMap = output;
  }


}
